export class PivotResponseData {
  practiceData: any;
  officeData: any;
  titleData: any;
  public constructor() {}
}
